import React from 'react';
import './header.css';
 
class Header extends React.Component  {
    
    render() { 
    return (
        <div className="header" id="flex">
            <div className="logo">
                <label>THE<span>LOGO</span></label>
                
            </div>
              {this.props.children}
            
        </div>
       
    )
    } 
    };
    
export default Header;